<template>
  <li class="mt-4">
    <span :id="'product-return-policy'" v-if="returnPolicy.returnable"
										data-test="returnPolicySectionReturnDays">
      {{returnPolicy.max_return_days}} Days Return Policy
      <span>
        <span class="question" data-test="returnPolicySectionSpan"
														id="returnPolicySectionSpan">?</span>
        <span class="field-tip" style="min-width: 90%">
          <span class="tip-content p-3" style="text-transform: capitalize">
            <h5 data-test="returnPolicySectionPolicyName"
																id="returnPolicySectionPolicyName">
													{{returnPolicy.return_policy_name}} Policy
												</h5>
            <span style="text-transform: none"
																		data-test="returnPolicySectionPolicy"
																		id="returnPolicySectionPolicy">
              {{returnPolicy.return_policy}}
            </span>
          </span>
        </span>
      </span>
    </span>
  </li>
</template>

<script>
export default {
	name: 'return-policy-section',
	props: {
		returnPolicy: {
			default: () => ({}),
			type: Object
		}
	}
}
</script>

<style scoped>
  .question {
    border-radius: 50%;
    background-color: #fff;
    color: #878787;
    font-weight: 500;
    width: 16px;
    height: 16px;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
    display: inline-block;
    border: 1px solid #e0e0e0;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, .2);
    vertical-align: middle;
    margin: 0 2px 0 8px;
    cursor: pointer;
  }

  .field-tip {
    display: none;
    position: absolute;
  }

  span:hover .field-tip {
    display: block;
  }

  .tip-content {
    overflow-y: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 150px;
    /*overflow:visible;*/
    background: #ffffff;
    display: block;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .2);
  }
</style>
